import { setAuthStatus } from "./auth-status";
import { sendPendingLogout } from "./logout";
import { refreshSession } from "./session";
import { isLogoutPending } from "./session-store";

const PROFILE_PATH = "/api/v1/auth/me/";

async function hasLegacySession(): Promise<boolean> {
  try {
    const response = await fetch(PROFILE_PATH, { credentials: "same-origin", cache: "no-store" });
    return response.ok;
  } catch {
    return false;
  }
}

export async function restoreSession(): Promise<void> {
  setAuthStatus("restoring");

  if (import.meta.env["VITE_MOCK_AUTH"] === "true") {
    setAuthStatus("mock");
    return;
  }

  if (isLogoutPending()) {
    await sendPendingLogout();
    setAuthStatus("signed_out");
    return;
  }

  const outcome = await refreshSession();
  if (outcome === "refreshed") {
    setAuthStatus("session");
    return;
  }
  if (outcome === "signed_out") {
    setAuthStatus((await hasLegacySession()) ? "legacy" : "signed_out");
    return;
  }
  setAuthStatus("unavailable");
}
